import { getCookie } from 'utilities/browser';

function getDySessionId () {

	return getCookie('_dyjsession') || window.DY?.jsession || '';

}

export default getDySessionId;
